import { render, staticRenderFns } from "./Consignor.vue?vue&type=template&id=662ff27b&scoped=true&"
import script from "./Consignor.vue?vue&type=script&lang=js&"
export * from "./Consignor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ff27b",
  null
  
)

export default component.exports